module.exports = "https://static.im-cdn.com/mjc/storefront/Ikkat/static/media/Pin.d83b4001.svg";